import dayjs, { Dayjs } from "dayjs";
import es from "dayjs/locale/es";

dayjs.locale(es);

type DateFormatterProps = {
  value: string | Date | Dayjs;

  /**
   * Docs: https://day.js.org/docs/en/display/format
   */
  template?: string;
};

/**
 *
 * ```jsx
 * import { DateFormatter } from "@/DateFormatter"
 * ```
 *
 * ```jsx
 *  <DateFormatter value={10500.333} />
 * ```
 *
 * - **value**:  string | Date | Dayjs
 * - **template?**: string = "DD/MM/YYYY HH:mm"  https://day.js.org/docs/en/display/format
 */
export function DateFormatter({ value, template = "DD/MM/YYYY HH:mm" }: DateFormatterProps) {
  return <>{dayjs(value).format(template)}</>;
}
